<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-scroll h-wrapper-680">
        <div class="h-dialogContainer">
        <div class="form-group h-col-inputBox">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('System.systemName')}}</div>
            <div class="h-toolbarBg h-system-height-60">
              <div class="h-inputBox">
                <form id="systemNameForm">
                  <div class="e-input-group">
                    <input class="e-input" v-model="systemName"  name="SystemName" />
                  </div>
                </form>
              </div>
              <ejs-button cssClass="e-small h-system-personalbtn"  @click.native="resetSysName">{{$t('System.reset')}}</ejs-button>
              <ejs-button cssClass="e-small h-system-personalbtn" :isPrimary="true" @click.native="saveSysName">{{$t('System.save')}}</ejs-button>
            </div>
          </div>
        </div>
          <div class="b-t"></div>
          <div class="form-group h-col-inputBox"></div>
          <div class="form-group h-col-inputBox">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('System.systemLogo')}}</div>
            <div class="h-toolbarBg">
              <ejs-button
                cssClass="e-small"
                :isPrimary="true"
                id="upButton"
                @click.native="upFile"
              >{{$t('System.selectFile')}}</ejs-button>
            </div>
            <div class="h-inputLit h-system-line-height-custom">{{$t('System.pngTip')}}</div>
          </div>
        </div>
        <div class="h-system-hide-upload">
          <ejs-uploader
            ref="file"
            name="file"
            id="filePersonal"
            autoUpload="false"
            :selected="onFileSelect"
            allowedExtensions=".png"
            :dropArea="dropElement"
            :multiple="false"
          ></ejs-uploader>
        </div>
        <div id="dropArea" style="display:none;padding-left:50px">
          <img id="imgShow" src width="83px" height="35px" />
          <ejs-button
            id="removeIcon"
            iconCss="icon hero-icon hero-icon-remove-small"
            cssClass="e-small e-round"
            :isPrimary="true"
            @click.native="removeImage"
          ></ejs-button>
        </div>
      </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import { EventBus } from '../../plugins/eventBus';
import mixin from '../../mixin/mixin';

export default {
  name: "Personal",
  mixins: [mixin],
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.systemSet')}/${this.$t('System.personal')}` },
      systemName: "",
      dropElement: ".control-fluid",
      parentElement: "",
      filesDetails: [],
      formObj:"",
      inputNames: ['SystemName'],
      rules: {
        SystemName: {regex: 'specialWordWithSpace',maxLength: 8},
    }
    };
  },
  components: {
    BasicLayout
  },
  methods: {
    resetSysName() {
      this.systemName = "";
      this.saveSysName();
      document.getElementById("SystemName-info").style.display = "none" ;
    },
    saveSysName() {
      const url = "/lte/ems/sysmanager/systempersonal/writeSystemName";
      if(!this.formObj.validate()){
        return null;
      }
      let formData = new FormData();
      formData.append("name", this.systemName);
      this.axios.post(url, formData).then(response => {
        if(response.status == 200 && response.data){
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Common.tips.success')}`});
        }else{
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('Common.tips.failure')}`});
        }
      });
    },
    onFileSelect(args) {
      const file = args.filesData[0];
      if (file.size > 1024 * 1024 * 2) {
        this.$refs.file.clearAll();
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('System.uploadTipsSize')}`});
        return null;
      }
      const imgWidth = `${this.$t('System.uploadImgWith')}`;
      const imgHeight = `${this.$t("System.uploadImgHeight")}`;
      let tipsWidth = `${this.$t('System.uploadTipsWidth')}`;
      let tipsHeight= `${this.$t('System.uploadTipsHeight')}`;
      const image = new Image();
      image.src = this.getObjectURL(file.rawFile);
      const That = this;
      image.onload = function () {
        if(image.width > imgWidth){
          EventBus.$emit('toast', {type: 'warning', content: tipsWidth});
          return null;
        }
        if(image.height > imgHeight){
          EventBus.$emit('toast', {type: 'warning', content: tipsHeight});
          return null;
        }
        That.uploadLogo(file);
      };
      document.getElementById("filePersonal").value = "";
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    removeImage() {
      document.getElementById("dropArea").style.display = "none";
      const element = document.getElementsByClassName('e-file-remove-btn')[0];
      element.click();
    },
    uploadLogo(file){
      this.$layer.confirm({
        msg: `${this.$t('System.uploadConfirm')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.confirm')}`,
          func: () => {
            const url = "/lte/ems/sysmanager/systempersonal/uploadLogo";
            let formData = new FormData();
            formData.append("file", file.rawFile);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            };
            this.axios.post(url, formData, config).then(response => {
              if(response.status == 200 && response.data.errorCode == 'SUCCESS'){
                EventBus.$emit('toast', {type: 'success', content: `${this.$t('System.uploadSuccess')}`});
                let imgURL = this.getObjectURL(file.rawFile);
                if (imgURL) {
                  document.getElementById("imgShow").src = imgURL;
                }
                document.getElementById("dropArea").style.display = "block";
              }else{
                EventBus.$emit('toast', {type: 'success', content: `${this.$t('System.uploadFault')}`});
              }
            });
          }
        }
      });
    },
    upFile() {
      document
        .getElementsByClassName("e-file-select-wrap")[0]
        .querySelector("button")
        .click();
      return false;
    }
  },
  mounted() {
    this.formObj = this.validateForm('systemNameForm', this.inputNames, this.rules);
  }
};
</script>
